// extracted by mini-css-extract-plugin
module.exports = {"mdBreakPoint":"992","closeMenuItems":"BjFXAu3pqhdxMvok","basketCount":"dmfpg6tycLxSiOW6","basketCountB2b":"_1-PSIigIj9uU18Nh"};